"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "OnDemandTranslationButton", {
  enumerable: true,
  get: function get() {
    return _OnDemandTranslationButton.default;
  }
});
Object.defineProperty(exports, "OnDemandTranslationContext", {
  enumerable: true,
  get: function get() {
    return _OnDemandTranslationContext.OnDemandTranslationContext;
  }
});
Object.defineProperty(exports, "OnDemandTranslationProvider", {
  enumerable: true,
  get: function get() {
    return _OnDemandTranslationContext.OnDemandTranslationProvider;
  }
});
Object.defineProperty(exports, "translateReply", {
  enumerable: true,
  get: function get() {
    return _actions.translateReply;
  }
});
Object.defineProperty(exports, "translateThread", {
  enumerable: true,
  get: function get() {
    return _actions.translateThread;
  }
});
Object.defineProperty(exports, "withOnDemandTranslationProps", {
  enumerable: true,
  get: function get() {
    return _withOnDemandTranslationProps.withOnDemandTranslationProps;
  }
});

var _OnDemandTranslationContext = require("./OnDemandTranslationContext");

var _withOnDemandTranslationProps = require("./withOnDemandTranslationProps");

var _actions = require("./actions");

var _OnDemandTranslationButton = _interopRequireDefault(require("./OnDemandTranslationButton"));